import {
    GET_MODEM_USAGE_FAILURE,
    GET_MODEM_USAGE_REQUEST,
    GET_MODEM_USAGE_SUCCESS,
    GET_MODEM_USAGE_POOLS_REQUEST,
    GET_MODEM_USAGE_POOLS_SUCCESS,
    GET_MODEM_USAGE_POOLS_FAILURE,
} from "actions/modemUsage";

const initialState = {
    details: null,
    loading: false,
    pools: [],
    error: null,
};

export default function modemUsage(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_MODEM_USAGE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_MODEM_USAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                details: payload,
                error: null,
            };
        case GET_MODEM_USAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_MODEM_USAGE_POOLS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_MODEM_USAGE_POOLS_SUCCESS:
            return {
                ...state,
                loading: false,
                pools: payload.items.map((it, i) => {
                    return {
                        id: i,
                        ...it
                    }
                }),
                error: null,
            };
        case GET_MODEM_USAGE_POOLS_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        default:
            return state;
    }
}